import { Col, Row, Modal, Input, Form, message, DatePicker, Select } from "antd";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useMutation } from "react-query";
import Title from "../UI/Title/Title";
import { createCount } from "../../api/inventoryCount";
import { CountInterface, WarehouseInterface } from "./Interfaces";

type prop = {
  isAddItemOpen: boolean;
  setIsAddItemOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setCounts: React.Dispatch<React.SetStateAction<CountInterface[]>>;
  setCountsSearch: React.Dispatch<React.SetStateAction<CountInterface[]>>;
  warehouses: WarehouseInterface[]
  warehousesLoading: boolean
  selectedWarehouseId: number | null
};

const AddCount = ({ isAddItemOpen, setIsAddItemOpen, setCounts, setCountsSearch, warehouses, warehousesLoading, selectedWarehouseId }: prop) => {
  const [t] = useTranslation("common");
  const [form] = Form.useForm();
  const [name, setName] = useState("");
  const [warehouseId, setWarehouseId] = useState(1);
  const [type, setType] = useState<"routine" | "end of year">("routine")

  const { mutateAsync: createCountMutation, isLoading: createCountLoading } = useMutation(
    "createCount",
    ({ name, type, warehouseId }: { name: string; type: string; warehouseId: number }) => {
      return createCount({ name, type, warehouseId, selectedWarehouseId })
    },
    {
      onSuccess: ({ data }) => {
        message.success(data.message);
        setCounts(data.data)
        setCountsSearch(data.data)
        setIsAddItemOpen(false);
        setName('')
      },
      onError: ({ response }) => {
        message.error(response ? response.data.message : "Error: Couldn't add a new count")
      },
    }
  );

  const handleName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleWarehouseId = (value: number) => {
    setWarehouseId(value);
  };

  const handleTypeChange = (value: "routine" | "end of year") => {
    setType(value)
  }

  const handleSubmit = () => {
    createCountMutation({ name, type, warehouseId });
  };

  return (
    <>
      <Modal
        centered
        okText={`${t("save")}`}
        open={isAddItemOpen}
        width={490}
        onCancel={() => setIsAddItemOpen(false)}
        closable={false}
        maskClosable={false}
        cancelText={`${t("cancel")}`}
        okButtonProps={{
          style: {
            height: "40px",
            background: "#1677FF",
            color: "#fff",
            width: "100px",
            backgroundColor: !name ? "grey" : "",
          },
          disabled: !name,
          loading: createCountLoading,
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        onOk={handleSubmit}
        destroyOnClose
      >
        <Form form={form} layout="vertical" preserve={false} initialValues={{ type: 'routine', warehouseId: 1 }}>
          <Row>
            <Col span={24}>
              <Title title={`${t("count")}`} />
            </Col>
            <Col span={24} className="modaltitleEdit">{`${t("add-count")}`}</Col>
            <Col span={16}>
              <Form.Item label={t("name")} name="name" rules={[{ required: true, message: `${t("enter-text")}` }]}>
                <Input maxLength={50} placeholder={`${t("enter-name")}`} onChange={handleName} />
              </Form.Item>
              <Form.Item
                label={t("type")}
                name="type"
              >
                <Select
                  onChange={(value: "routine" | "end of year") => handleTypeChange(value)}
                >
                  <Select.Option key={1} value={"routine"}>
                    Routine
                  </Select.Option>
                  <Select.Option key={2} value={"end of year"}>
                    End of Year
                  </Select.Option>
                </Select>
              </Form.Item>
              <Form.Item
                label={t("warehouse")}
                name="warehouseId"
                rules={[{ required: true, message: `${t("select-warehouse")}` }]}
              >
                <Select
                  placeholder={`${t("select-warehouse")}`}
                  onChange={(value) => handleWarehouseId(value)}
                  loading={warehousesLoading}
                >
                  {warehouses.map((warehouse) => (
                    <Select.Option key={warehouse.id} value={warehouse.id}>
                      {warehouse.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddCount;
